export default __webpack_public_path__ + "static/media/motorbridge2x.dc1bc440.png";